import React from "react";
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";
import app from "..";
import { ReactComponent as GoogleIcon } from "./google_icon.svg";
import "./google_login_button.css";
import { useTranslation } from "react-i18next";

const GoogleLoginButton = ({ callback }) => {
  const { t } = useTranslation();
  const handleGoogleLogin = async () => {
    //     const auth = getAuth(app);
    //     try {
    //       const provider = new OAuthProvider("apple.com");
    //       provider.addScope("email");
    //       provider.addScope("name");
    //       const result = await signInWithPopup(auth, provider);
    //       const user = result.user;
    //       const idToken = await user.getIdToken();
    //       callback({
    //         idToken: idToken,
    //         email: user.email,
    //         lang: navigator.language,
    //       });
    //     } catch (error) {
    //       console.error("Login Error:", error);
    //     }
  };

  return (
    <button className="google-signin-button" onClick={handleGoogleLogin}>
      <GoogleIcon
        className="Google-logo"
        style={{ marginRight: "5px" }}
      ></GoogleIcon>
      {t("sign_in_with_google")}
    </button>
  );
};

export default GoogleLoginButton;
